import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import toFeedbackDto from '../../../models/adapters/FeedbackAdapter';
import { feedbackFailed, feedbackReceived, sendFeedback, SendFeedbackActionType } from '../../actions/feedback/sendFeedback';
import getPublicResponse from '../getPublicResponse';

function* sendFeedbackSaga({ payload }: SendFeedbackActionType) {
  const timestamp = moment();
  const { feedback } = payload;
  const feedbackDto = toFeedbackDto(feedback);
  const response = yield getPublicResponse(PublicServerPlaceEvent.createFeedback, { feedbackDto });
  const { error } = response;
  const responsePayload = { feedback, timestamp };
  if (!error) {
    const responseAction = feedbackReceived(responsePayload);
    yield put(responseAction);
  } else {
    const responseAction = feedbackFailed(responsePayload);
    yield put(responseAction);
  }
}

export default function* watchSendFeedbackSaga() {
  yield takeEvery(sendFeedback, sendFeedbackSaga);
}
